export default {
  busy (state) {
    state.loading++
  },
  free (state) {
    state.loading--
  },
  rates (state, rates) {
    state.rates = rates
  },
  availabilityRequest (state, request) {
    state.availabilityRequest = request
  },
  rooms (state, rooms) {
    state.rooms = rooms
  },
  focus (state, element) {
    state.focus = element
  },
  changePaymentOption (state, option) {
    state.selectedPayment = option
    state.focus = undefined
  },
  isLogged (state, option) {
    state.isLogged = option
  },
  error (state, error) {
    state.error = error
  },
  exchangeRates (state, exchangeRates) {
    state.exchangeRates = exchangeRates
  },
  selectedCurrency (state, currencyCode) {
    state.selectedCurrency = currencyCode
  },
  matchesRatesFound (state, found) {
    state.matchesRatesFound = found
  },
  customer (state, customer) {
    state.customer = customer
  },
  labelsLoaded (state, labelsLoaded) {
    state.labelsLoaded = labelsLoaded
  },
  nearbyHotels (state, hotels) {
    state.nearbyHotels = hotels
  },
  nearbyPlace (state, place) {
    state.nearbyPlace = place
  },
  selectedHotel (state, code) {
    state.selectedHotel = {
      ...code ? state.nearbyHotels.find(hotel => hotel.code === code) : {}
    }
  },
  socialMedia (state, socialMedia) {
    state.socialMedia = socialMedia
  },
  overviewPath (state, overviewPath) {
    state.overviewPath = overviewPath
  },
  minNightsFromRate (state, minNightsPerStay) {
    state.minNightsPerStay = minNightsPerStay
  },
  tmsCode (state, tmsCode) {
    state.tmsCode = tmsCode
  },
  currentCategory (state, category) {
    state.currentCategory = category
  },
  loadingRate (state, loadingRate) {
    state.loadingRate = loadingRate
  },
  checkInTime (state, checkInTime) {
    state.checkInTime = checkInTime
  },
  checkOutTime (state, checkOutTime) {
    state.checkOutTime = checkOutTime
  },
  displayLoyaltyRates (state, display) {
    state.displayLoyaltyRates = display
  },
  memberOnlyRate (state, memberOnlyRate) {
    state.memberOnlyRate = memberOnlyRate
  },
  isTier (state, tierDiscount) {
    state.isTier = tierDiscount
  },
  travelAgencyCustomerId (state, customerId) {
    state.travelAgencyCustomerId = customerId
  },
  promotionalCodeGroupId (state, groupId) {
    state.promotionalCodeGroupId = groupId
  },
  onlyAccessible (state, onlyAccessible) {
    state.onlyAccessible = onlyAccessible
  },
  hotelName (state, hotelName) {
    state.hotelName = hotelName
  },
  setQubitTracker (state, cookie) {
    state.qubitTracker = cookie
  }
}
